import { IIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a raised hand.
 */
export function HandRaisedIcon({
  className,
  strokeWidth = 1,
  variant,
}: Readonly<IIconProps>) {
  if (variant !== 'solid') {
    return (
      <svg className={className} fill="none" viewBox="0 0 24 24">
        <path
          d="M10.05 4.575a1.574 1.574 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 1 1 3.15 0v1.5m-3.15 0 .075 5.925M6.9 7.575a1.575 1.575 0 0 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.576 1.576 0 0 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.3-7.425v6.675m0-6.675a1.575 1.575 0 1 1 3.15 0V15m0 0a4.49 4.49 0 0 0-3.18 1.318M16.35 15h.002"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24">
      <path d="M10.5 1.875a1.125 1.125 0 1 1 2.25 0v8.219c.517.162 1.02.382 1.5.659V3.375a1.125 1.125 0 1 1 2.25 0v10.937a4.506 4.506 0 0 0-3.25 2.373 8.963 8.963 0 0 1 4-.935A.75.75 0 0 0 18 15v-2.266c.003-.89.359-1.742.988-2.37a1.125 1.125 0 0 1 1.591 1.59 1.119 1.119 0 0 0-.329.79v3.006h-.005a6 6 0 0 1-1.752 4.007l-1.736 1.736a6 6 0 0 1-4.242 1.757H10.5a7.5 7.5 0 0 1-7.5-7.5V6.375a1.125 1.125 0 0 1 2.25 0v5.519c.46-.452.965-.832 1.5-1.141V3.375a1.125 1.125 0 0 1 2.25 0v6.526c.495-.1.997-.151 1.5-.151V1.875Z" />
    </svg>
  );
}
